import React, { useEffect, useState } from 'react';
import UI from '../../ui';
import Utils from '../../utils';
import { Instructions } from '../Instructions';
import { FormatedCarrierMapping } from '../Mappings';
import { InboundStatus } from '../Status';
import { ValidationErrors } from '../Validations';

const {
	WrappedDropdownWithLabel,
	WrappedInputTextWithLabel,
	WrappedButton,
	WrappedButtonType,
} = UI;

const { Util } = Utils;

const { getCarrierName } = Util;

const TrackingInfoItem = ({
	carrierOptions,
	showMobileView,
	isMobile,
	onActionTrigger,
	trackingIndex,
	trackingInfoItem,
	inboundStatus,
	onDeleteButtonClick,
	updateShippingInstructions,
	validations,
	updateValidation,
}) => {
	const { trackingNumber, carrier, wasCarrierSet } = trackingInfoItem;
	const trackingInfoNumber = trackingNumber || '';
	const [selectedCarrier, setSelectedCarrier] = useState(
		FormatedCarrierMapping[carrier]
	);
	let trackingValidation = validations.tracking[trackingIndex];

	useEffect(() => {
		const formattedCarrier = FormatedCarrierMapping[carrier];
		if (formattedCarrier) {
			setSelectedCarrier(formattedCarrier);
		} else {
			setSelectedCarrier(carrier);
		}
	}, [carrier]);

	const onTrackingNumberChange = e => {
		const { value, name } = e.target;
		const updatedValidations = validations;

		trackingValidation = value.length < 255 ? 1 : -1;
		updatedValidations.tracking[trackingIndex] = trackingValidation;

		updateValidation(updatedValidations);

		onActionTrigger(trackingIndex, name, value);

		// Try to infer the carrier from tracking number if user has not previously set it
		if (!wasCarrierSet) {
			onActionTrigger(trackingIndex, 'carrier', getCarrierName(value));
		}
	};

	const onCarrierChange = e => {
		const { value, name } = e.target;

		setSelectedCarrier(value);
		onActionTrigger(trackingIndex, name, value);
		onActionTrigger(trackingIndex, 'wasCarrierSet', true);
	};

	const onDelete = () => {
		onDeleteButtonClick(trackingIndex);
	};

	const onTrackingFocus = () => {
		updateShippingInstructions(
			Instructions.headers.shipping.tracking,
			Instructions.instructions.shipping.tracking
		);
	};

	const mobileClassName = isMobile ? 'mobile-wrapper' : '';

	const editableTrackingItem = (
		<div
			className={`p-grid p-col-12 tracking-item ${
				showMobileView ? 'p-dir-col' : 'p-dir-row'
			}`}
		>
			{showMobileView && (
				<WrappedButton
					buttonType={WrappedButtonType.Icon}
					icon="delete-icon"
					className="p-col p-col-align-end delete-tracking"
					onClick={onDelete}
					dataqa="tracking-item-delete"
				/>
			)}

			<WrappedInputTextWithLabel
				className={`${showMobileView ? 'p-col-12' : 'p-md-9 p-lg-9'} ${mobileClassName}`}
				label={showMobileView ? 'Tracking Number' : ''}
				isInputInvalid={trackingValidation === -1}
				showErrorBelow={isMobile}
				errorMessage={ValidationErrors.trackingNumberMax}
				uiElementConfig={{
					name: 'trackingNumber',
					value: trackingInfoNumber,
					onChange: onTrackingNumberChange,
					onFocus: onTrackingFocus,
					placeholder: 'Optional',
					dataqa: 'inbound-tracking-info-tracking-number',
				}}
			/>

			<WrappedDropdownWithLabel
				className={`${
					showMobileView ? 'p-col-12' : 'p-md-2 p-lg-2'
				} ${mobileClassName} carrier`}
				label={showMobileView ? 'Carrier' : ''}
				uiElementConfig={{
					name: 'carrier',
					options: carrierOptions,
					optionLabel: 'label',
					optionValue: 'label',
					value: selectedCarrier,
					onChange: onCarrierChange,
					placeholder: 'Optional',
					dataqa: 'inbound-tracking-carrier-options',
				}}
			/>

			{!showMobileView && (
				<WrappedButton
					buttonType={WrappedButtonType.Icon}
					icon="delete-icon"
					className="p-lg-1 p-md-1 delete-tracking"
					onClick={onDelete}
					dataqa="tracking-info-item-delete"
				/>
			)}
		</div>
	);

	const nonEditableTrackingItem = (
		<div
			className={`p-grid p-col-12 tracking-item ${
				showMobileView ? 'p-dir-col' : 'p-dir-row'
			}`}
		>
			<div
				className={`${showMobileView ? 'p-col-12' : 'p-md-9 p-lg-9'} ${mobileClassName}`}
			>
				{trackingInfoNumber}
			</div>
			<div
				className={`${showMobileView ? 'p-col-12' : 'p-md-2 p-lg-2'} ${mobileClassName}`}
			>
				{selectedCarrier}
			</div>
		</div>
	);

	return (
		<>
			{inboundStatus !== InboundStatus.Completed &&
				inboundStatus !== InboundStatus.Cancelled &&
				editableTrackingItem}
			{(inboundStatus === InboundStatus.Completed ||
				inboundStatus === InboundStatus.Cancelled) &&
				nonEditableTrackingItem}
		</>
	);
};

export default TrackingInfoItem;
